import theme from 'src/utils/theme';

/* We need to match hubspot breakpoints to make headers look similar */
export const desktopMinWidthBP = '90rem' as const;

export const desktopFullHeight = `calc(${theme.sz.s10} + ${theme.sz.s20})`;
